import {audioManager, AudioType} from '../Sound'
import {setElementInnerHTML, setElementOnClick} from '../ui_utils/DomUtils'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables'
import {CA} from '../analytics/Analytics'
import {AjaxDataTypes} from '../../../../shared/AjaxDataTypes'
import {AnalyticEventCategory, AnalyticEventType, AnalyticEventValue} from '../../../../shared/entity_datas/EntityDatas'
import {replaceLanguageInPath} from '../ClientI18n'
import {navigateToPage} from '../ui_utils/ClientUtils'
import {ClientUserState} from '../ClientUserState'

export class UICoinsController {
    private readonly userCoinsDiv: HTMLHeadingElement
    protected readonly headerCoinsContainer: HTMLDivElement

    constructor() {
        this.userCoinsDiv = document.getElementById('header_coins') as HTMLHeadingElement
        this.headerCoinsContainer = document.getElementById('header_coins_container') as HTMLDivElement
        ClientUserState.registerChangeListener((userState) => {
            if(userState == undefined) return
            this.setCoins(userState.items.colonistCoins)
        })
        this.initCoinClick()
    }

    private setCoins(coinAmount: number) {
        setElementInnerHTML(this.userCoinsDiv, {key: 'strings:colonistCommon.utils.#buffer', options: {value: coinAmount}})
    }

    protected initCoinClick() {
        setElementOnClick(this.headerCoinsContainer, () => {
            audioManager.play(AudioType.Click)
            this.sendCoinClickAnalytic()
            const storePath = replaceLanguageInPath('/store', UIUtilsEjsVariables.language)
            navigateToPage(storePath)
        })
    }

    // eslint-disable-next-line class-methods-use-this
    protected sendCoinClickAnalytic() {
        const eventData: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.ABTestClickAnalytics,
            category: AnalyticEventCategory.ABTestClickAnalytics,
            floatValue: AnalyticEventValue.HeaderCoinPlusButton,
        }
        void CA.sendAnalyticEvent(eventData)
    }
}

